export default "__VITE_ASSET__CogzUrZe__"